import React, { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import { BackArrowIcon, EditIcon } from "../../../Assets/Icons";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import CreateGroup from "./CreateGroup";
import CreateUser from "./CreateUser";
import apiClient from "../../../apiClient";
import { CREATE_CHANNEL_GROUP, GET_CHANNEL_LIST, GET_DIRECTORY_LIST, CATEGORY_TAGS_LIST } from "../../../apiClient/apiEndpoints";
import { categoryIds, SSO_URL } from "../../../env";
import { useSelector } from "react-redux";
import { debounce } from "../../../Utils/general";

const { BackButton, SimInputBar, DropdownSearch } = UiComponents;

const OrganizationCreation = () => {
  const navigate = useNavigate();
  let userData = useSelector((state) => state.userSlice);
  const [directoryList, setDirectoryList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const backClick = () => navigate(-1);

  const [organizationDetails, setOrganizationDetails] = useState({
    avatar: null,
    name: "",
    website: "",
    directory: null,
  });

  const [groupDetails, setGroupDetails] = useState({
    logo: null,
    name: "",
    website: null,
    channel: null,
    identifier: null,
    industry: [],
    address: {
      address1: null,
      address2: null,
      city: "",
      state: null,
      country: null,
      pincode: null,
    },
  });

  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    uid: "",
    phone: null,
    designation: null,
    password: "",
  });

  const getDirectoryList = async () => {
    try {
      let data = await apiClient(`${SSO_URL}${GET_DIRECTORY_LIST}`);
      let list = data.map((e) => ({ value: e.uuid, label: e.name, type: e.type }));
      setDirectoryList(list);
    } catch (error) {
      console.log(error);
    }
  };

  const getChannelList = async () => {
    try {
      let data = await apiClient(`${SSO_URL}${GET_CHANNEL_LIST}`);
      let list = data.map((e) => ({ value: e.uuid, label: e.name, type: e.type }));
      setChannelList(list);
    } catch (error) {
      console.log(error);
    }
  };


  const getTagsList = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/${categoryIds["INDUSTRIES"]}`);
      setTagsList(data.map(e => ({ value: e.id, label: e.name })))
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDirectoryList();
    getChannelList();
    getTagsList();
  }, []);

  const handleReset = () => {

    setOrganizationDetails({
      avatar: null,
      name: "",
      website: "",
      directory: null,
    });

    setGroupDetails({
      logo: null,
      name: "",
      website: null,
      channel: null,
      identifier: null,
      address: {
        address1: null,
        address2: null,
        city: "",
        state: null,
        country: null,
        pincode: null,
      },
    });

    setUserDetails({
      name: "",
      email: "",
      uid: "",
      phone: null,
      designation: null,
      password: "",
    });
  };

  const validateDetails = () => {
    let errorStatus = false;

    const raiseError = (message) => {
      setError(message);
      errorStatus = true;
    };

    const groupRequiredFields = [
      { condition: !groupDetails.name.trim(), message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.channel, message: "Kindly fill all (*) fields." },
      { condition: groupDetails.industry.length === 0, message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.address?.country, message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.address?.state, message: "Kindly fill all (*) fields." },
      { condition: !groupDetails.address?.city.trim(), message: "Kindly fill all (*) fields." }
    ];

    for (const field of groupRequiredFields) {
      if (field.condition) {
        raiseError(field.message);
        return true;
      }
    }

    if (userDetails.email.length === 0 && userDetails.uid.length === 0) {
      errorStatus = true;
      setError("kindly fill email or uid.");
    }
    if (userDetails.uid.length > 0 && userDetails.password.length === 0) {
      errorStatus = true;
      setError("kindly fill all(*) fields.");
    }

    return errorStatus;
  };

  const handleCreateOrganization = async () => {
    if (loading) return;
    try {
      setError(null);

      if (validateDetails()) return;

      setLoading(true);

      let bodyData = {
        // channel: {
        //   avatar: organizationDetails.avatar,
        //   name: organizationDetails.name,
        //   website: organizationDetails.website,
        //   directory: organizationDetails.directory.value,
        // },
        group: {
          name: groupDetails.name.trim(),
          logo: groupDetails.logo,
          identifier: groupDetails.identifier,
          address: groupDetails.address,
          website: groupDetails.website,
          channel: groupDetails.channel,
          industryIds: groupDetails.industry.map(e => e.value),
          uuid: uuidv4()
        },
        user: {
          name: userDetails.name,
          email: userDetails.email || null,
          uid: userDetails.uid || null,
          phone: userDetails.phone,
          designation: userDetails.designation,
          password: userDetails.password,
          uuid: uuidv4()
        },
      };

      await apiClient.post(`${SSO_URL}${CREATE_CHANNEL_GROUP}`, bodyData);
      handleReset();

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClicked = () => {
    handleReset();
  };

  const handleDebounceCreate = debounce(handleCreateOrganization, 500);

  return (
    <div className="org-creation">
      <div className="page-title" style={{ border: "none" }}>
        <div className="title-back">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <h6>Create Organization </h6>
        </div>
      </div>

      <div className="sim-section-wrapper">
        <div className="sim-section">
          {/* <div className="input-section-wrapper">
            <CreateOrganization organizationDetails={organizationDetails} setOrganizationDetails={setOrganizationDetails} directoryList={directoryList} handleCancelClicked={handleCancelClicked} handleDebounceCreate={handleDebounceCreate} />
          </div> */}

          <div className="input-section-wrapper">
            <CreateGroup
              loading={loading}
              error={error}
              groupDetails={groupDetails}
              setGroupDetails={setGroupDetails}
              channelList={channelList}
              tagsList={tagsList}
              handleCancelClicked={handleCancelClicked}
              handleDebounceCreate={handleDebounceCreate}
            />
          </div>

          <div className="input-section-wrapper">
            <CreateUser userDetails={userDetails} setUserDetails={setUserDetails} disable={false} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCreation;
